import script from "./Temporary.vue?vue&type=script&lang=js"
export * from "./Temporary.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__